import { Box, Divider, makeStyles } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import React from 'react';
const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
        borderRadius: 12,
    },
    icon: {
        height: 12,
        width: 12,
        marginLeft: spacing(1),
    },
    blue: {
        // @ts-ignore: blue is not a material-ui recognized value under 'common'
        backgroundColor: palette.common.blue,
        color: palette.common.white,
    },
    green: {
        // @ts-ignore: green is not a material-ui recognized value under 'common'
        backgroundColor: palette.common.green,
        color: palette.common.white,
    },
    purple: {
        // @ts-ignore: purple is not a material-ui recognized value under 'common'
        backgroundColor: palette.common.purple,
        color: palette.common.white,
    },
    basic: {
        backgroundColor: palette.divider,
        color: palette.text.primary,
    },
    divider: {
        marginTop: -3,
        marginBottom: -5,
        marginLeft: 6,
        marginRight: 6,
        height: 'calc(100% + 9px)',
        backgroundColor: palette.grey[300],
    },
}));
export const Pill = props => {
    const { colorType, label, dividedValue, classes: classesProp, ...rest } = props;
    const classes = useStyles();
    const labelComponent = dividedValue ? (React.createElement(Box, { display: "inline-flex", height: "15px" },
        label,
        React.createElement(Divider, { orientation: "vertical", className: classes.divider }),
        dividedValue)) : (label);
    return (React.createElement(Chip, Object.assign({ className: colorType ? classes[colorType] : classes.basic, classes: {
            root: classes.root,
            icon: classes.icon,
            ...classesProp,
        }, label: labelComponent }, rest)));
};
export default Pill;
//# sourceMappingURL=Pill.js.map